import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ClaimTable from './ClaimTable'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import { axiosInstance } from '../Config'
import secureLocalStorage from 'react-secure-storage'
import Loader from '../Loader'
import { Modal } from 'antd'
import { toast } from 'react-toastify'
import moment from 'moment'
import ClaimDetails from './ClaimDetails'
import { CalculateTotal } from './CalculateTotal'

const ClaimIndex = () => {

    const [data, setData] = useState([])
    const user_id = secureLocalStorage.getItem('credentials');

    const [allLessons, setAllLessons] = useState([])
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [open, setOpen] = useState(false)
    const [lessonData, setLessonData] = useState({})
    const [Total, setTotal] = useState(0);
    const [ClaimData, setTotalData] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0)
        getSessionsInfo()
    }, [])

    function getSessionsInfo() {
        setLoading(true)

        axiosInstance.get(`get-claims/${user_id?.id}`, {
            headers: {
                Authorization: `Bearer ${user_id.token}`
            }
        })
            .then(res => {
                setData(res?.data?.claims?.reverse() || [])
                setAllLessons(res?.data?.claims || [])
                const Total = CalculateTotal(res?.data?.lessons || [], res?.data?.claims || [])

                console.log("Total", Total)
                setTotal(Total.Total);
                setTotalData(Total.result);
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    const navigate = useNavigate()

    const handleCopyClick = (rowData, index) => {

        // Copy the text to the clipboard
        navigator.clipboard.writeText(rowData)
            .then(() => {
                toast.success('Link Copied !');
            })
            .catch(err => toast.error('Error copying text: '));
    };

    const [items_perpage, setItemsPerPage] = useState(10)

    const total_pages = Math.ceil(data?.length / items_perpage);

    const final_data = data?.slice(page * items_perpage - items_perpage, page * items_perpage)


    console.log("final_data", final_data)

    const changePage = (pagecount) => {
        if (pagecount > 0 && pagecount <= total_pages) {
            setPage(pagecount)
            window.scrollTo(0, 0)
        }
    }

    const filterByName = (e) => {
        const filteredData = allLessons.filter((lesson) =>
            lesson?.lesson?.instructor?.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
            lesson?.lesson?.cources?.title.toLowerCase().includes(e.target.value.toLowerCase())
        )

        setData(filteredData)
    }

    const [ClaimModal, setClaimModal] = useState(false);

    return (
        <>
            {
                loading && <Loader />
            }

            <ContainerDashboard title="Claim History" description="Everything here">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">

                        <div className="col-md-12 ">
                            <div className="p-4 py-5 bg-gradientt rounded-4" style={{ minHeight: '75vh' }}>

                                <div className='d-md-flex justify-content-between align-items-start mb-4'>
                                    <div className="ps-section__search  d-flex justify-content-end mb-4">
                                        <div
                                            className="ps-form--search-simple"
                                        >
                                            <input
                                                className="form-control bg-white"
                                                type="text"
                                                placeholder="Search Claim History.."
                                                onChange={filterByName}
                                            />
                                            <button type='button'>
                                                <i className="icon icon-magnifier"></i>
                                            </button>
                                        </div>
                                        <select className='form-select ms-3 fs-5'
                                            value={items_perpage}
                                            onChange={(e) => setItemsPerPage(e.target.value)}
                                            style={{ width: '110px' }}>
                                            <option value="5">Show 5</option>
                                            <option value="10">Show 10</option>
                                            <option value="20">Show 20</option>
                                            <option value="30">Show 30</option>
                                        </select>
                                    </div>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <h4 className='text-green mb-0 me-2'>Total : <br className='d-block d-xl-none' /> <i className="bi bi-currency-pound"></i>{Total.toFixed(2)}</h4>
                                        <button className="h-100 button btn-green text-white ms-3" type='button' onClick={() => setClaimModal(true)}>
                                            <i className="bi bi-cash me-2"></i>Claim
                                        </button>
                                        <button type="button" onClick={() => navigate(-1)} className="h-100 button btn-black text-white ms-3">
                                            <i className='icon-arrow-left me-3 fs-5'></i>
                                            back</button>
                                    </div>

                                </div>

                                <ClaimTable data={final_data}
                                    handleCopyClick={handleCopyClick}
                                    setData={setAllLessons}
                                    setOpen={setOpen}
                                    setLessonData={setLessonData}
                                />

                                {/* pagination */}
                                <div className='d-flex flex-column align-items-end mt-5'>
                                    <p className='mb-4'>Show {final_data?.length} of {data?.length} items.</p>
                                    <div className='d-flex justify-content-md-start justify-content-center flex-wrap'>

                                        <div className={`bd-number-pagination rounded-2 me-3 mt-2`}
                                            onClick={() => changePage(page - 1)}>
                                            <i className='icon-arrow-left'></i>
                                        </div>

                                        {
                                            [...Array(total_pages)].map((_, pagecount) => {
                                                pagecount += 1
                                                return (
                                                    <div key={pagecount} className={`bd-number-pagination rounded-2 mx-1 pe-1 mt-2 ${page === pagecount && 'activepage'}`} onClick={() => changePage(pagecount)}>
                                                        {pagecount < 10 ? ('0' + pagecount) : pagecount}
                                                    </div>
                                                )
                                            })
                                        }

                                        <div className={`bd-number-pagination rounded-2 ms-3 mt-2`}
                                            onClick={() => changePage(page + 1)}>
                                            <i className='icon-arrow-right'></i>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </ContainerDashboard>

            {/* view */}
            <Modal
                open={open}
                title="Claim Details"
                centered
                onCancel={() => setOpen(false)}
                width={850}
                bodyStyle={{ padding: '0' }}
                footer={null}
            >
                <div className='Claim-Modal'>
                    <div className="bg-gradientt p-4">
                        <div className='p-2 pb-0'>
                            <table className='table table-bordered' style={{ verticalAlign: 'middle' }}>
                                <tbody>
                                    <tr>
                                        <th className='col-4 text-green p-3 bg-light'>Claim Date</th>
                                        <td className='p-3'>{moment(lessonData?.created_at).format("DD MMM, YYYY")}</td>
                                    </tr>

                                    <tr>
                                        <th className='col-4 text-green p-3 bg-light'>Total Lessons In Claim</th>
                                        <td className='p-3'>{lessonData?.totallesson ? lessonData?.totallesson : "--"}</td>
                                    </tr>

                                    <tr>
                                        <th className='col-4 text-green p-3 bg-light'>Amount (£)</th>
                                        <td className='p-3'>£ {lessonData?.amount?.toFixed(2) || "0.00"}</td>
                                    </tr>

                                    <tr>
                                        <th className='col-4 text-green p-3 bg-light'>Claim Status</th>
                                        <td className='p-3'>{lessonData?.paymentproofUrl ? 'Claimed' : 'Requested for claim'}</td>
                                    </tr>

                                    <tr>
                                        <th className='col-4 text-green p-3'>Payment Proof</th>
                                        <td className='p-3'>
                                            {
                                                lessonData?.paymentproofUrl ?
                                                    <a href={lessonData?.paymentproofUrl} download className='text-primary' target='_blank'>  Download proof</a> : <span className='text-danger'>NA</span>
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className='bg-white p-3 mt-4'>
                                <h4 className='mb-0'>Lesson Details</h4>
                            </div>
                            <div className='table-responsive'>
                                <table className="jean-table table">
                                    <tbody>
                                        {lessonData && (
                                            (() => {
                                                const Lessons = lessonData?.lessondetails ? JSON?.parse(lessonData?.lessondetails) : []; // Parse the lesson details JSON

                                                return Lessons.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="therapist-info">
                                                                <h4 className="mb-1 fs-5">Student Name</h4>
                                                                <p className="mb-0">
                                                                    {item?.customerName || "--"} {/* Replace with dynamic customer name */}
                                                                </p>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="therapist-info">
                                                                <h4 className="mb-1 fs-5">Course Name</h4>
                                                                <p className="mb-0">
                                                                    {item?.courseName || "--"} {/* Replace with dynamic course name */}
                                                                </p>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="therapist-info">
                                                                <h4 className="mb-1 fs-5">Date</h4>
                                                                <p className="mb-0">
                                                                    {item?.bookingDate ? moment(item.bookingDate).format("DD MMM, YYYY") : "--"}
                                                                    {/* Replace with dynamic start date */}
                                                                </p>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="therapist-info">
                                                                <h4 className="mb-1 fs-5">Time</h4>
                                                                <p className="mb-0">
                                                                    {item?.slotTime || "--"}
                                                                    {/* Replace with dynamic start date */}
                                                                </p>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="therapist-info">
                                                                <h4 className="mb-1 fs-5">Slots</h4>
                                                                <p className="mb-0">
                                                                    {item?.completedDays || 5} {/* Replace with dynamic completed slots */}
                                                                </p>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="therapist-info">
                                                                <h4 className="mb-1 fs-5">Amount</h4>
                                                                <p className="mb-0">
                                                                    <i className="bi bi-currency-pound me-1"></i>{item?.amount?.toFixed(2) || "0.00"} {/* Replace with dynamic amount */}
                                                                </p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ));
                                            })()
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                open={ClaimModal}
                title="Add Claims"
                width={1000}
                onCancel={() => setClaimModal(false)}
                bodyStyle={{ padding: '0' }}
                footer={null}
            >
                <ClaimDetails
                    data={ClaimData}
                    OverallTotal={Total}
                    setClaimModal={setClaimModal}
                    getSessionsInfo={getSessionsInfo}
                    setMainTotal={setTotal}
                    setTotalData={setTotalData}
                />
            </Modal>
        </>
    )
}

export default ClaimIndex